import Chip from '@mui/material/Chip';

import type StatusChipProps from './StatusChip.types';
import getStatusColor from './statusColor.utils';

const StatusChip = (props: StatusChipProps) => {
  const { status } = props;

  return (
    <Chip variant="outlined" label={status} color={getStatusColor(status)} />
  );
};

export default StatusChip;
